//=======================================
// Import btn components
//=======================================
import BtnCircleIcon from './buttons/btnCircleIcon';
import BtnUnderline from './buttons/btnUnderline';
import BtnTab from './buttons/btnTab';

//=======================================
// Import icon svg components ui
//=======================================
import IconDashboard from './icons/iconDashboard';
import IconRef from './icons/iconRef';
import IconEval from './icons/iconEval';
import IconPosition from './icons/iconPosition';
import IconSettings from './icons/iconSettings';
import IconRetractSidenav from './icons/iconRetractSidenav';
import IconRefNew from './icons/iconRefNew';
import IconEvalNew from './icons/iconEvalNew';
import IconWarning from './icons/iconWarning';
import IconLoader from './icons/iconLoader';
import IconMail from './icons/iconMail';
import IconCloud from './icons/iconCloud';
import IconEdit from './icons/iconEdit';
import IconList from './icons/iconList';
import IconShare from './icons/iconShare';
import IconDelete from './icons/iconDelete';
import IconLaurels from './icons/iconLaurels';
import IconHelp from './icons/iconHelp';
import IconFlag from './icons/iconFlag';

//=======================================
// Import icon svg strengths scores
//=======================================
import IconP1 from './icons/iconP1';
import IconP2 from './icons/iconP2';
import IconP3 from './icons/iconP3';
import IconP4 from './icons/iconP4';
import IconP5 from './icons/iconP5';
import IconP6 from './icons/iconP6';
import IconP7 from './icons/iconP7';
import IconP8 from './icons/iconP8';
import IconP9 from './icons/iconP9';
import IconP10 from './icons/iconP10';

//=======================================
// Import forms elements components
//=======================================
import CoeffSlider from './inputs/coeffSlider';
import SkillScoreRadios from './inputs/skillScoreRadios';
import SkillScoreRadioWrapper from './inputs/skillScoreRadioWrapper';
import InputMaterialWrap from './inputs/inputMaterialWrap';
import TextareaMaterialWrap from './inputs/textareaMaterialWrap';
import RefSelectByCat from './inputs/refSelectByCat';
import SwitchInput from './inputs/switch';

//=======================================
// Import ui elements components
//=======================================
import alert from './ui/alert';
import SightRadialProgress from './ui/sightRadialProgress';
import Modal from './ui/modal';
import CompletedMark from './ui/completedMark'
import SearchBar from './ui/searchBar'
import TableHeadSortable from './ui/tableHeadSortable'
import TableSelectCheckbox from './ui/tableSelectCheckbox'
import NotifText from './ui/notifText'
import TableDeleteButton from './ui/tableDeleteButton'
import FavoriteCheckbox from './ui/favoriteCheckbox'
import TableWrapper from './ui/tableWrapper'
import DropDown from './ui/dropDown'
import BooleanIcon from './ui/booleanIcon'
import LocaleSwitcher from './ui/localeSwitcher'


export default [
    BtnCircleIcon,
    BtnUnderline,
    BtnTab,

    IconDashboard,
    IconRef,
    IconEval,
    IconPosition,
    IconSettings,
    IconRetractSidenav,
    IconRefNew,
    IconEvalNew,
    IconWarning,
    IconLoader,
    IconMail,
    IconCloud,
    IconEdit,
    IconList,
    IconShare,
    IconDelete,
    IconLaurels,
    IconHelp,
    IconFlag,

    IconP1,
    IconP2,
    IconP3,
    IconP4,
    IconP5,
    IconP6,
    IconP7,
    IconP8,
    IconP9,
    IconP10,

    CoeffSlider,
    SkillScoreRadioWrapper,
    SkillScoreRadios,
    InputMaterialWrap,
    TextareaMaterialWrap,
    RefSelectByCat,
    SwitchInput,

    alert,
    SightRadialProgress,
    Modal,
    CompletedMark,
    SearchBar,
    TableHeadSortable,
    TableSelectCheckbox,
    NotifText,
    TableDeleteButton,
    FavoriteCheckbox,
    TableWrapper,
    DropDown,
    BooleanIcon,
    LocaleSwitcher
];